import React from "react";
import { FaGraduationCap } from "@react-icons/all-files/fa/FaGraduationCap";
// @ts-ignore
import mergeClassNames from "merge-class-names";
import classes from "./subjectIcon.module.css";

interface SubjectIconProps {
  icon: string;
  selected?: boolean;
}

function SubjectIcon({ icon, selected }: SubjectIconProps) {
  return (
    <div className={mergeClassNames(classes.root, selected ? classes.selected : "")}>
      <FaGraduationCap className={classes.icon} />
    </div>
  );
}

export default SubjectIcon;
